import type React from 'react';
import type { LoadingProgressBarProps } from './LoadingProgressBar.types';

export const LoadingProgressBar: React.FC<LoadingProgressBarProps> = ({ value, className = '' }) => {
  // Clamp value between 0 and 100
  const clampedValue = Math.min(Math.max(value, 0), 100);

  return (
    <div
      className={`w-full h-1 bg-white/20 rounded-full overflow-hidden ${className}`}
      role="progressbar"
      aria-valuenow={clampedValue}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="h-full bg-white transition-all duration-100 ease-out" style={{ width: `${clampedValue}%` }} />
    </div>
  );
};
